// [IMPORT] Utils & Variables
import DataSet      from '../util/urDataSet.js';

// [IMPORT] Sub mixins module
import commonMixin  from './urCommonGridMixin';
import rowActMixin  from './data/urDataGridRowActMixin';
import sortMixin    from './data/urDataGridSortMixin';

import {copyArr, isNull} from '../util';

//===========================================
// DATA mixins
//    데이터 조작을 위한 기능을 구현합니다.
//    데이터는 
//        . 밖에서 입력받은 Props
//        . 이를 활용하기 위하여 Props 정보를 기반으로 가공한 internal data
//        .
//    ,
//    그를 도움하기 위한 함수 및 urDataGrid 하위의 Component들을 위한 sharedData를 포함합니다.

export default {
    mixins : [commonMixin, sortMixin, rowActMixin],
    data() {return {
        mx_dataSet     : new DataSet(),
        vars_accordionRow : null,
    }},
    computed : {
        // [COPMUTED][VARS] Data size
        vars_dataSize() {
            // urCommonGridMixin.js
            return this.itemSize || this.mx_dataSet.dataSize;
        },
        // [COPMUTED][VARS] View size
        vars_viewSize() {
            return this.mx_dataSet.viewSize;
        },
        // [COPMUTED][VARS] Selected length
        vars_selLen() {// for reactive
            return this.mx_dataSet.selLen
        }
    },
    watch : {
        dataSource : {immediate:true, handler(v) {
            this.mx_setData(v);
        }},
        "mx_dataSet.dataUpdated" : {immediate:true, handler(v,w) {
            this.mx_fireEvent('data-changed',this.mx_getChanged());
            this.mx_buildData(v);
        }},
    },
    methods : {
        // [METHOD][DATA] set data to grid
        mx_setData(v) {
            // /*TEST CODE*/console.debug('[DATA] methods.mx_setData :',this.__i1=1+(this.__i1||0));
            // 1. set data
            if(!v) {
                // 1.x ERROR : no DATA
                return null;
            } else if(v instanceof DataSet) {
                // 1.1 set data : dataSet
                this.mx_dataSet = v;
                this.mx_dataSet.setKeyField(this.vars_keyField);
            } else if(Array.isArray(v)) {
                if(!this.mx_dataSet || !(this.mx_dataSet instanceof DataSet)) {
                    // 1.X ERROR : we lost prepared dataSet
                    console.warn('[UIDev] MAYBE, You cannot approach here. we prepare dataSet already.')
                    this.mx_dataSet = new DataSet(v);
                    this.mx_dataSet.setKeyField(this.vars_keyField);
                } else {
                    // 1.2 set data : dataarray
                    this.mx_dataSet.setKeyField(this.vars_keyField);
                    this.mx_dataSet.setData(v)
                }
            } else {
                // 1.X ERROR : unexpected case
                console.warn('[UIDev] Fail to refresh data. We receive unexpected value.')
                return null;
            }
            
            // x. scroll top
            this.mx_eventBus.$emit('set-scroll-top',0);
            
            return this.mx_dataSet;
        },
        // [METHOD][DATA] append data to grid
        mx_appendData(v) {
            this.mx_dataSet.appendData(v);
            this.mx_buildData();
            this.$nextTick(()=>{
                this.mx_eventBus.$emit('scroll-adjust');
            })
        },
        // [METHOD][DATA] unshfit data to grid
        mx_unshiftData(v) {
            this.mx_dataSet.unshiftData(v);
            this.mx_buildData();
            let nextY = this.mx_refs.scrollWrapper.scrollTop + (this.mx_options.rowHeight*v.length);
            this.$nextTick(()=>{
                this.mx_eventBus.$emit('set-scroll-top',nextY);
            })
        },
        // [METHOD][DATA] Copy data from origin to mx_data
        mx_buildData() {
            /*TEST CODE*/console.debug('[DATA] methods.buildData :',this.__i32=1+(this.__i32||0));
            let filter    = this.mx_options.externalFilter ? [] : this.mx_filtered,
                filterGrp = this.mx_options.externalFilter ? [] : this.mx_filter_forced,
                sorter    = this.mx_options.externalSort   ? [] : this.mx_sort_fields,
                sorterGrp = this.mx_options.externalSort   ? [] : this.mx_sort_forced;
            
            let grps = this.mx_options.grouping;
            if(!isNull(grps)) {
                this.mx_dataSet.buildGroupData(grps, filter, sorter, filterGrp, sorterGrp);
                this.mx_buildGroupTreeOffset(this.mx_dataSet.data, 0);
            } else {
                this.mx_dataSet.buildData(filter, sorter);
            }
            this.mx_buildViewData();
            // x. Unset something..
            this.mx_toggleEditCancel();
        },
        // [LOCAL][DATA] Build Tree offset
        mx_buildGroupTreeOffset(_arr, _offset){
            let arr = _arr || this.mx_dataSet.data,
                offset = _offset || 0;
            let rh = this.mx_options.rowHeight; //1?
            let isVertAcc = this.mx_options.accordionVertical>0 || !!this.vars_freezeWidth;
            let gh = this.mx_options.groupHeader ? this.mx_options.groupRowHeight : 0;
            let sh = this.mx_options.groupSummary? this.mx_options.groupSummaryHeight : 0;
            arr.forEach(o=>{
                o.__st = offset;
                if(o.group) {
                    offset += gh + sh;
                    if(o.leaf&&o.expand) {
                        offset += o.children.reduce((acc,row)=> {
                            return acc+(!isVertAcc&&row.__accordion?row.__accordionHeight||0:0)+rh;
                        },0);
                    } else if(o.expand) {
                        offset = this.mx_buildGroupTreeOffset(o.children, offset)
                    }
                }
                o.__ed = offset-(offset===o.__st?0:1);
            })
            return offset;
        },
        // [METHOD][DATA] build view data
        mx_buildViewData() {
            if(this.mx_options.internalPaging) {
                let pager = this.mx_pager;
                let st = pager.firstIndex
                  , ed = Math.min(st + pager.rowsPerPage,this.vars_dataSize);
                this.mx_dataSet.buildViewData({st, ed});
            } else {
                this.mx_dataSet.buildViewData();
            }
            
            // x. Do something..
            if(this.mx_options.cellMode) {
                this.mx_clearCellSelect();
            }
        },
        // [METHOD][DATA] get data(view)
        mx_getRawData() {
            return this.mx_dataSet.getRawData();
        },
        // [METHOD][DATA] get data(view)
        mx_getViewData() {
            return this.mx_dataSet.getViewData();
        },
        // [METHOD][DATA] Set value for full/data grid logic sync
        mx_setValue(row, fieldKey, value) {
            if(!row) return null;
            //row[fieldKey] = value;
            this.mx_dataSet.setRowValue(row.__id, fieldKey, value)
            return value
        },
        // [METHOD][DATA] Get row with rowId.
        mx_getRow(rowId) {
            return this.mx_dataSet.getRow(rowId);
        },
        // [METHOD] Open context menu
        mx_openAccordion(row, value) {
            // 1. Close previous
            if(this.vars_accordionRow) { // open multiple?
                this.mx_setValue(this.vars_accordionRow, '__accordion', false)
            }
            // 2. Open next
            this.mx_setValue(row, '__accordion', value)
            this.vars_accordionRow = value ? this.mx_dataSet.getRow(row.__id):null; // need copy?
        }
    },
}